import React, { useEffect, useState } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import { Modal, Button } from 'react-bootstrap';
import { ManageBranchService } from '../api/services';
import DatePicker from "react-datepicker";
const ManageAdmin = () => {
  //Update recharge info
    const [rechargeModalVisible, setRechargeModalVisible] = useState(false);
    const [rechargeDate, setRechargeDate] = useState('14 Jan 2026');
    const [daysValid, setDaysValid] = useState('');
    const [planAmount, setPlanAmount] = useState('');
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [errors, setErrors] = useState({});

    const validateDaysValid = (days) => {
      if (!days || days.trim() === '') return 'Days  is required';
      if (isNaN(days) || Number(days) <= 0) return 'Enter a valid number';
      return '';
    };

    const validatePlanAmount = (amount) => {
      if (!amount || amount.trim() === '') return 'Plan amount is required';
      if (isNaN(amount) || Number(amount) <= 0) return 'Enter a valid amount';
      return '';
    };

    const handleRechargeSubmit = () => {
  debugger
  const daysError = validateDaysValid(daysValid);
  const amountError = validatePlanAmount(planAmount);

  if (daysError || amountError) {
    setErrors({
      daysValid: daysError,
      planAmount: amountError,
    });
    return;
  }
   
  const Payload = {
    device_id: selectedDevice.id,
    device_no: selectedDevice.code,
    mobile_no: mobileNumber,
    recharge_date: rechargeDate,
    days_of_validity: daysValid,
    recharge_plane: planAmount
  }
  setIsLoading(true);
  ManageBranchService.updateRechargeInfo(Payload).then((res) => {
    console.log(res)
    alert(res.data.results || "Updated Successfully")
    setRechargeModalVisible(false);
    setPopupShow(true); // ✅ Show Device Management Modal again
    
    // Reset form
    setDaysValid('');
    setPlanAmount('');
    setRechargeDate('');
    setErrors({});
    setIsLoading(false);
  }).catch((err) => {
    console.error('Failed to Add title:', err)
    setIsLoading(false);
  });
};
  


  ///
  

  const validateName = (value) => {
    if (!value.trim()) return "Name is required";
    if (value.length < 3) return "Name must be at least 3 characters";
    return "";
  };

  const validateMobile = (value) => {
    if (!value.trim()) return "Mobile number is required";
    if (!/^[0-9]{10}$/.test(value)) return "Mobile number must be 10 digits";
    return "";
  };
  const openDeviceInfoPopup = (device) => {
    setPopupShow(false); // Hide Device Management Modal
    setSelectedDevice(device);
    setDeviceName(device.name || "");
    setMobileNumber(device.mobile_no || "");
    setcardCode(device.code || "");
    setErrors({});
    setShowDeviceInfoModal(true); // Show Device Info Modal
  };
    const openRechargeInfoPopup = (device) => {
  setPopupShow(false); // Hide Device Management Modal
  setSelectedDevice(device);
  setMobileNumber(device.mobile_no || "");
  setRechargeDate('14 Jan 2026');
  setDaysValid('');
  setPlanAmount('');
  setShowDatePicker(false);
  setErrors({});
  setRechargeModalVisible(true); // Show Recharge Info Modal
};

  const closeDeviceInfoPopup = () => {
  setShowDeviceInfoModal(false);
  setPopupShow(true); // Show Device Management Modal again
  
  // Optional but recommended resets
  setSelectedDevice(null);
  setDeviceName("");
  setMobileNumber("");
  setErrors({});
};
const shoowDeviceInfoMOdal = () =>{
      setShowDeviceInfoModal(true)
      setPopupShow(false)
};


const [selectedDevice, setSelectedDevice] = useState(null);
 const [showDeviceInfoModal, setShowDeviceInfoModal] = useState(false);



  const [deviceName, setDeviceName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [cardCode, setcardCode] = useState("");
  const [AdminListData, setAdminListData] = useState([]);
  const navigate = useNavigate();
  const [adminData, setAdminData] = useState({});
  const [IsLoading, setIsLoading] = useState(false);
  //Cards
  const [cardData, setCardData] = useState('');
  const [allocatedCards, setAllocatedCards] = useState([]);
  const [availableCards, setAvailableCards] = useState([]);

  const [IsCheckBoxCards, setIsCheckBoxCards] = useState(false);
  const [IsBtnCancelCards, setIsBtnCancelCards] = useState(false);
  const [IsBtnDeleteCards, setIsBtnDeleteCards] = useState(false);
  const [IsBtnAddMoreCards, setIsBtnAddMoreCards] = useState(false);

  const [IsAllDeleteCards, setIsAllDeleteCards] = useState(true);
  const [IsCheckAllBoxCards, setIsCheckAllBoxCards] = useState(false);
  const [checkedCards, setCheckedCards] = useState({});
  const [checkedAllCards, setCheckedAllCards] = useState(false);

 //DevicesCards
  const [deviceData, setDeviceData] = useState('');
  const [allocatedDevices, setAllocatedDevices] = useState([]);
  const [availableDevices, setAvailableDevices] = useState([]);

  const [IsCheckBox, setIsCheckBox] = useState(false);
  const [IsBtnCancel, setIsBtnCancel] = useState(false);
  const [IsBtnDelete, setIsBtnDelete] = useState(false);
  const [IsBtnAddMore, setIsBtnAddMore] = useState(false);

  const [IsAllDelete, setIsAllDelete] = useState(true);
  const [IsCheckAllBox, setIsCheckAllBox] = useState(false);
  const [checked, setChecked] = useState({});
  const [checkedAll, setCheckedAll] = useState(false);

  //popup
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [deviceShow, setPopupShow] = useState(false);
  const devicePopupClose = () => setPopupShow(false);
  const devicePopupShow = () => setPopupShow(true);

  const [popupDeviceShow, setPopupDeviceShow] = useState(false);
  const handlePopupDeviceClose = () => setPopupDeviceShow(false);
  const handlePopupDeviceShow = () => setPopupDeviceShow(true);

  const [cardShow, setCardShow] = useState(false);
  const cardPopupClose = () => setCardShow(false);
  const cardPopupShow = () => setCardShow(true);

   const [popupCardShow, setPopupCardShow] = useState(false);
   const handlePopupCardClose = () => setPopupCardShow(false);
   const handlePopupCardShow = () => setPopupCardShow(true);
//transaction History
  const [OrganizationListData, setOrganizationListData] = useState([]);
  



   const getMonthLabel = (date) => {
    return date.toLocaleString('default', { month: 'long', year: 'numeric' });
  };
  useEffect(() => {
    let TokenVal = localStorage.getItem('jwtToken');
    if (TokenVal === null || TokenVal === "" || TokenVal === undefined) {
      navigate("/");
    }
    setIsBtnAddMore(true);
    setIsBtnAddMoreCards(true);
    setIsCheckAllBox(false);
    setIsCheckAllBoxCards(false);
    fnAdmininfoLoad();
    // const interval = setInterval(() => {
    //   fnAdmininfoLoad();
    // }, 500);
    // return () => clearInterval(interval);
  }, []);

  //Devices
  useEffect(() => {
    let allChecked = true;
    for (const inputName in checked) {
      if (checked[inputName] === false) {
        allChecked = false;
      }
    }
    if (allChecked) {
      setCheckedAll(true);
    } else {
      setCheckedAll(false);
    }

    let allCheckedcards = true;
    for (const inputName in checkedCards) {
      if (checkedCards[inputName] === false) {
        allCheckedcards = false;
      }
    }
    if (allCheckedcards) {
      setCheckedAllCards(true);
    } else {
      setCheckedAllCards(false);
    }
 
  }, [checked, checkedCards]);

  // List of admin
  function fnAdmininfoLoad() {

    // var axios = require('axios');
    const BASE_URL = window.BASE_URL + '/get_admins_info';
    var config = {
      method: 'get',
      url: BASE_URL,
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
      }
    };
    axios.request(config)
      .then(function (response) {
        setAdminListData([]);

        if (response !== null && response !== undefined && response.data !== null && response.data !== undefined && response.data.results !== null && response.data.results.length > 0)
          setAdminListData(response.data.results);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  //Create Admin
  const fnCreateAdminClick = (e) => {
    navigate("/SuperAdmin/CreateAdmin");
  };

  //Count of devices and cards
  const fnAdmininfoClick = (Values, e) => {
    debugger
    setAdminData(Values);
    var data = JSON.stringify({
      "admin_id": Values.admin_id,
    });

    const BASE_URL = window.BASE_URL + '/get_InventryCounts';
    //setIsLoading(true);
    var config = {
      method: 'post',
      url: BASE_URL,

      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
        'Content-Type': 'application/json',
      },
      maxBodyLength: Infinity,
      data: data
    };

    axios.request(config)
      .then((response) => {

        if (response !== null && response !== undefined && response.data !== null && response.data !== undefined && response.data.results !== null) {
          setDeviceData(response.data.results.totalDevices);
          setCardData(response.data.results.totalCards);
          fetchOrganizations( Values.admin_id)
          handleShow();
        }
      })
      .catch((error) => {
        console.log(error);
      });
   
   
  };

  // Devices check box
  function fnCommontoggleclick(inputName, index) {
    setChecked((prevState) => {
      const newState = { ...prevState };
      newState[inputName] = !prevState[inputName];
      return newState;
    });
  }
    
const fnSubmitDeviceUpdate = () => {
  const nameError = validateName(deviceName);
  const mobileError = validateMobile(mobileNumber);

  if (nameError || mobileError) {
    setErrors({
      name: nameError,
      mobile: mobileError,
    });
    return;
  }

  const payload = {
    device_id: selectedDevice.id,
    device_name: deviceName,
    mobile_no: mobileNumber,
  };

  setIsLoading(true);
  
  ManageBranchService.UpdateDevice(payload).then((res) => {
    alert("Device Updated successfully")
    setShowDeviceInfoModal(false);
    setPopupShow(true); // ✅ Show Device Management Modal again
    
    // Reset form
    setSelectedDevice(null);
    setDeviceName("");
    setMobileNumber("");
    setcardCode("");
    setErrors({});
    setIsLoading(false);
  }).catch((err) => {
    console.error('Something Went Wrong!', err)
    alert('Something Went Wrong!')
    setIsLoading(false);
  });
};


  //Device checkbox 
  function fnCommonSelectclick(value) {
    setCheckedAll(value);
    setChecked((prevState) => {
      const newState = { ...prevState };
      for (const inputName in newState) {
        newState[inputName] = value;
      }
      return newState;
    });
  }

  const toggleCheck = (input, inx) => {
    fnCommontoggleclick(input, inx)
  };

  const selectAll = (tempval) => {
    fnCommonSelectclick(tempval)
  };

  // function fnDeviceClick() {
  //   var data = JSON.stringify({
  //     "admin_id": adminData.admin_id,
  //   });
    
  //   const BASE_URL = window.BASE_URL + '/get_allocated_devices';
  //   //setIsLoading(true);
  //   var config = {
  //     method: 'post',
  //     url: BASE_URL,

  //     headers: {
  //       'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
  //       'Content-Type': 'application/json',
  //     },
  //     maxBodyLength: Infinity,
  //     data: data
  //   };

  //   axios.request(config)
  //     .then((response) => {

  //       setAllocatedDevices([]);
  //       if (response !== null && response !== undefined && response.data !== null && response.data !== undefined && response.data.results !== null && response.data.results.length > 0) {
  //         var tempdata = response.data.results;
  //         setAllocatedDevices(tempdata);
  //         for (var i = 0; i < tempdata.length; i++) {
  //           var temp = tempdata[i].id;
  //           checked[temp] = false;
  //         }
  //         setCheckedAll(false);
  //       }
  //     })
  //     .catch((error) => {
  //       // setIsLoading(false);
  //       console.log(error);
  //     });

  //     devicePopupShow();
  // };
  async function fnDeviceClick() {
  const data = JSON.stringify({
    "admin_id": adminData.admin_id,
  });
  
  const BASE_URL = window.BASE_URL + '/get_allocated_devices';
  setIsLoading(true);
  
  const config = {
    method: 'post',
    url: BASE_URL,
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
      'Content-Type': 'application/json',
    },
    maxBodyLength: Infinity,
    data: data
  };

  try {
    const response = await axios.request(config);

    setAllocatedDevices([]);
    if (response !== null && response !== undefined && response.data !== null && response.data !== undefined && response.data.results !== null && response.data.results.length > 0) {
      var tempdata = response.data.results;
      setAllocatedDevices(tempdata);
      for (var i = 0; i < tempdata.length; i++) {
        var temp = tempdata[i].id;
        checked[temp] = false;
      }
      setCheckedAll(false);
    }
    setIsLoading(false);
  } catch (error) {
    setIsLoading(false);
    console.log(error);
  }

  devicePopupShow();
}
  function fnRemoveClick() {
    setIsCheckBox(true);
    setIsAllDelete(false);
    setIsCheckAllBox(true);
    setIsBtnAddMore(false);
    setIsBtnDelete(true);
    setIsBtnCancel(true);
  };

  const fnRemoveDeviceClick = () => {

    let reqArr = [];
    setChecked((prevState) => {
      const newState = { ...prevState };
      for (let prop in newState) {
        if (newState.hasOwnProperty(prop)) {
          if (newState[prop] === true) {
            reqArr.push(prop);
          }
        }
      }
      if (reqArr !== null && reqArr != [] && reqArr.length > 0) {
        var data = JSON.stringify({
          "admin_id": adminData.admin_id,
          "device_ids": reqArr
        });

        const BASE_URL = window.BASE_URL + '/remove_devices';
        //setIsLoading(true);

        var config = {
          method: 'post',
          url: BASE_URL,

          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
            'Content-Type': 'application/json',
          },
          maxBodyLength: Infinity,
          data: data
        };

        axios.request(config)
          .then((response) => {

            if (response !== null && response !== undefined && response.data !== null && response.data !== undefined && response.data.results !== null) {
              let tempArr = [];
              tempArr = [...allocatedDevices];
              const resp = response.data.results
              const arrRes = Object.keys(resp).map(i => Number(i));
              let res = tempArr.filter(item => !arrRes.includes(item.id));
              setDeviceData(res.length);
              setAllocatedDevices(res);
            }
          })
          .catch((error) => {
            // setIsLoading(false);
            console.log(error);
          });
      }
      return newState;
    });
  }

  function fnCancelClick() {
    fnDevicecommonclosePopup();
    fnCommonClosePopup();
  }

  function fnDeviceclosePopup() {
    fnDevicecommonclosePopup();
    fnCommonClosePopup();
    devicePopupClose();
  }

  function fnDevicecommonclosePopup() {
    setIsBtnCancel(false);
    setIsBtnDelete(false);
    setIsBtnAddMore(true);
    setIsCheckBox(false);
    setIsAllDelete(true);
  }

  function fnCloseAddMorePopup() {

    fnCommonClosePopup();
    handlePopupDeviceClose();
  }

  function fnCommonClosePopup() {
    setIsCheckAllBox(false);
    setCheckedAll(false);
    setChecked((prevState) => {
      const newState = { ...prevState };
      for (const inputName in newState) {
        newState[inputName] = false;
      }
      return newState;
    });
  }

  // Add more devices
  function fnAddMoreClick() {

    var data = JSON.stringify({
      "admin_id": 0,
    });

    const BASE_URL = window.BASE_URL + '/get_available_devices';
    //setIsLoading(true);
    var config = {
      method: 'post',
      url: BASE_URL,

      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
        'Content-Type': 'application/json',
      },
      maxBodyLength: Infinity,
      data: data
    };

    axios.request(config)
      .then((response) => {
        setAvailableDevices([]);
        if (response !== null && response !== undefined && response.data !== null && response.data !== undefined && response.data.results !== null && response.data.results.length > 0) {

          var tempdata = response.data.results;
          setAvailableDevices(tempdata);
          for (var i = 0; i < tempdata.length; i++) {
            var temp = tempdata[i].id;
            checked[temp] = false;
          }
          setCheckedAll(false);
        }
      })
      .catch((error) => {
        // setIsLoading(false);
        console.log(error);
      });

    handlePopupDeviceShow();
  }

  // Add more check boxes
  const toggleCheckDevices = (input, inx) => {
    fnCommontoggleclick(input, inx);
  }
  
  const selectAllDevices = (tempval) => {
    fnCommonSelectclick(tempval)
  }

  //Allocate devices
  const fnAllocateNowClick = () => {

    let reqArr = [];

    setChecked((prevState) => {
      const newState = { ...prevState };
      for (let prop in newState) {
        if (newState.hasOwnProperty(prop)) {
          if (newState[prop] === true) {
            reqArr.push(prop);
          }
        }
      }

      if (reqArr !== null && reqArr != [] && reqArr.length > 0) {
        var data = JSON.stringify({
          "admin_id": adminData.admin_id,
          "device_ids": reqArr
        });

        const BASE_URL = window.BASE_URL + '/allocate_device';
        //setIsLoading(true);

        var config = {
          method: 'post',
          url: BASE_URL,

          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
            'Content-Type': 'application/json',
          },
          maxBodyLength: Infinity,
          data: data
        };

        axios.request(config)
          .then((response) => {
            if (response !== null && response !== undefined && response.data !== null && response.data !== undefined && response.data.results !== null) {
              let tempArr = [];
              let tempRes = [];
              tempArr = [...availableDevices];
              const resp = response.data.results
              let arrRes = Object.keys(resp).map(i => Number(i));
              let tempAvailableD = tempArr.filter(item => !arrRes.includes(item.id));
              const tempAllocatedD = tempArr.filter(index => {
                return arrRes.find(selected => selected === index.id)
              });
              tempRes = [...allocatedDevices, ...tempAllocatedD];
              setAllocatedDevices(tempRes);
              setDeviceData(tempRes.length);
              setAvailableDevices(tempAvailableD);
            }
          })
          .catch((error) => {
            // setIsLoading(false);
            console.log(error);
          });
      }
      return newState;
    });
  }

  // Cards
  function fnCardClick() {
    
    var data = JSON.stringify({
      "admin_id": adminData.admin_id,
    });

    const BASE_URL = window.BASE_URL + '/get_allocated_cards';
    //setIsLoading(true);
    var config = {
      method: 'post',
      url: BASE_URL,

      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
        'Content-Type': 'application/json',
      },
      maxBodyLength: Infinity,
      data: data
    };

    axios.request(config)
      .then((response) => {
        
        setAllocatedCards([]);
        if (response !== null && response !== undefined && response.data !== null && response.data !== undefined && response.data.results !== null && response.data.results.length > 0) {
          var tempdata = response.data.results;
          setAllocatedCards(tempdata);
          for (var i = 0; i < tempdata.length; i++) {
            var temp = tempdata[i].id;
            checkedCards[temp] = false;
          }
          setCheckedAllCards(false);
        }
      })
      .catch((error) => {
        // setIsLoading(false);
        console.log(error);
      });

      cardPopupShow();
  }
  
  function fnCommontoggleCardclick(inputName, index) {
    
    setCheckedCards((prevState) => {
      const newState = { ...prevState };
      newState[inputName] = !prevState[inputName];
      return newState;
    });
  }

  //Cards checkbox 
  function fnCommonSelectCardsclick(value) {
    setCheckedAllCards(value);
    setCheckedCards((prevState) => {
      const newState = { ...prevState };
      for (const inputName in newState) {
        newState[inputName] = value;
      }
      return newState;
    });
  }

  const toggleCheckCards = (input, inx) => {
    fnCommontoggleCardclick(input, inx)
  };

  const selectAllCards = (tempval) => {
    fnCommonSelectCardsclick(tempval)
  };

  function fnCardclosePopup() {
    fnCardcommonclosePopup();
    fnCardCommonClose();
    cardPopupClose();
  }

  function fnCardcommonclosePopup() {
    setIsBtnCancelCards(false);
    setIsBtnDeleteCards(false);
    setIsBtnAddMoreCards(true);
    setIsCheckBoxCards(false);
    setIsAllDeleteCards(true);
  }

  function fnCardCommonClose() {
    setIsCheckAllBoxCards(false);
    setCheckedAllCards(false);
    setCheckedCards((prevState) => {
      const newState = { ...prevState };
      for (const inputName in newState) {
        newState[inputName] = false;
      }
      return newState;
    });
  }

  function fnRemoveCardsClick() {
    setIsCheckBoxCards(true);
    setIsAllDeleteCards(false);
    setIsCheckAllBoxCards(true);
    setIsBtnAddMoreCards(false);
    setIsBtnDeleteCards(true);
    setIsBtnCancelCards(true);
  };

  const fnDeleteCardsClick = () => {
   
    let reqArr = [];
    setCheckedCards((prevState) => {
      const newState = { ...prevState };
      for (let prop in newState) {
        if (newState.hasOwnProperty(prop)) {
          if (newState[prop] === true) {
            reqArr.push(prop);
          }
        }
      }
      if (reqArr !== null && reqArr != [] && reqArr.length > 0) {
        var data = JSON.stringify({
          "admin_id": adminData.admin_id,
          "card_ids": reqArr
        });

        const BASE_URL = window.BASE_URL + '/remove_cards';
        //setIsLoading(true);

        var config = {
          method: 'post',
          url: BASE_URL,

          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
            'Content-Type': 'application/json',
          },
          maxBodyLength: Infinity,
          data: data
        };

        axios.request(config)
          .then((response) => {

            if (response !== null && response !== undefined && response.data !== null && response.data !== undefined && response.data.results !== null) {
              let tempArr = [];
              tempArr = [...allocatedCards];
              const resp = response.data.results
              const arrRes = Object.keys(resp).map(i => Number(i));
              let res = tempArr.filter(item => !arrRes.includes(item.id));
              setCardData(res.length);
              setAllocatedCards(res);
            }
          })
          .catch((error) => {
            // setIsLoading(false);
            console.log(error);
          });
      }
      return newState;
    });
  }

  function fnCancelCardsClick() {
    fnCardcommonclosePopup();
    fnCardCommonClose();
  }

   // Add more Cards
  function fnAddMoreCardsClick() {

    var data = JSON.stringify({
      "admin_id": 0,
    });

    const BASE_URL = window.BASE_URL + '/get_available_cards';
    //setIsLoading(true);
    var config = {
      method: 'post',
      url: BASE_URL,

      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
        'Content-Type': 'application/json',
      },
      maxBodyLength: Infinity,
      data: data
    };

    axios.request(config)
      .then((response) => {
        
        setAvailableCards([]);
        if (response !== null && response !== undefined && response.data !== null && response.data !== undefined && response.data.results !== null && response.data.results.length > 0) {

          var tempdata = response.data.results;
          setAvailableCards(tempdata);
          for (var i = 0; i < tempdata.length; i++) {
            var temp = tempdata[i].id;
            checkedCards[temp] = false;
          }
          setCheckedAllCards(false);
        }
      })
      .catch((error) => {
        // setIsLoading(false);
        console.log(error);
      });

    handlePopupCardShow();
  }

   function fnCloseAddMoreCardsPopup() {

    fnCardCommonClose();
    handlePopupCardClose();
  }

   //Allocate Cards
  const fnAllocateCardsNowClick = () => {

    let reqArr = [];

    setCheckedCards((prevState) => {
      const newState = { ...prevState };
      for (let prop in newState) {
        if (newState.hasOwnProperty(prop)) {
          if (newState[prop] === true) {
            reqArr.push(prop);
          }
        }
      }

      if (reqArr !== null && reqArr != [] && reqArr.length > 0) {
        var data = JSON.stringify({
          "admin_id": adminData.admin_id,
          "card_ids": reqArr
        });

        const BASE_URL = window.BASE_URL + '/allocate_card';
        //setIsLoading(true);

        var config = {
          method: 'post',
          url: BASE_URL,

          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
            'Content-Type': 'application/json',
          },
          maxBodyLength: Infinity,
          data: data
        };

        axios.request(config)
          .then((response) => {
            if (response !== null && response !== undefined && response.data !== null && response.data !== undefined && response.data.results !== null) {
              let tempArr = [];
              let tempRes = [];
              tempArr = [...availableCards];
              const resp = response.data.results
              let arrRes = Object.keys(resp).map(i => Number(i));
              let tempAvailableC = tempArr.filter(item => !arrRes.includes(item.id));
              const tempAllocatedC = tempArr.filter(index => {
                return arrRes.find(selected => selected === index.id)
              });
              tempRes = [...allocatedCards, ...tempAllocatedC];
              setAllocatedCards(tempRes);
              setCardData(tempRes.length);
              setAvailableCards(tempAvailableC);
            }
          })
          .catch((error) => {
            // setIsLoading(false);
            console.log(error);
          });
      }
      return newState;
    });
  }

  
   
 const fetchOrganizations = async (adminId) => {
      const token = localStorage.getItem('jwtToken');

      if (!token) {
        navigate("/");
        return;
      }
       
      try {
        setIsLoading(true);
        const BASE_URL = window.BASE_URL + '/get_organizations';
        const data = JSON.stringify({
          "admin_id":adminId,
        });
        const config = {
              method: 'post',
              url: BASE_URL,

              headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
                'Content-Type': 'application/json',
              },
              maxBodyLength: Infinity,
              data: data
            };


        const response = await axios.request(config);

        if (response != null && response != undefined && response.data != null && response.data != undefined && response.data.results != null && response.data.results.length > 0) {
          setOrganizationListData(response.data.results);
          sessionStorage.setItem('devicesadminId', adminId)
        } else {
          setOrganizationListData([]);
        }
         setIsLoading(false);
      } catch (error) {
        console.error("Error fetching organizations:", error);
        setIsLoading(false);
      }
    };
  const fnCreateOrganizationClick = (e) => {
    navigate("/SuperAdmin/CreateOrganization/"+adminData.admin_id);
  }
 const handleTransactionsClick = (user_Id) => {
  debugger
  const currentDate = new Date();
  setSelectedMonth(currentDate);    
  handleClose()         // reset month to current
  setShowTransactionsModal(true);            // open modal
  fetchTransactionsForMonth(user_Id, currentDate); // fetch transactions
  // setCurrentUserId(user_Id);
  };
// --- States for Transaction Modal ---
const [showTransactionsModal, setShowTransactionsModal] = useState(false);
const [activeTab, setActiveTab] = useState("daily"); // daily | monthly
const [showPickerModal, setShowPickerModal] = useState(false);

const [selectedDate, setSelectedDate] = useState(new Date());
const [selectedMonth, setSelectedMonth] = useState(new Date());
const [dailyTransactions, setDailyTransactions] = useState([]);
const [monthlyTransactions, setMonthlyTransactions] = useState([]);
const [isLoadingTransactions, setIsLoadingTransactions] = useState(false);

// --- Pagination ---
const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 10;

// --- Helpers ---
const getDateLabel = (date) =>
  date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });

const formatMonthYear = (date) =>
  `${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;

const formatMonthYearDisplay = (date) =>
  date.toLocaleDateString("en-GB", { month: "short", year: "numeric" });

// --- API Fetchers ---
const fetchTransactionsForMonth = (userId, date) => {
  const payload = { user_id: userId, month: formatMonthYear(date) };
  setIsLoading(true);
  ManageBranchService.get_user_transactions(payload)
    .then((res) => {
      setMonthlyTransactions(res.data.results || []);
      setIsLoading(false);
    })
    .catch(() => {
      setMonthlyTransactions([]);
      setIsLoading(false);
    });
};

const fetchTransactionsForDayWise = (userId, currDate) => {
  debugger
  const payload = { user_id: userId, month: formatMonthYear(currDate) };
 setIsLoading(true);
  ManageBranchService.get_user_transactions(payload)
    .then((res) => {
      const allTransactions = res.data.results || [];
      const filtered = allTransactions.filter((tx) => {
        const txDate = new Date(tx.transaction_time);
        return (
          txDate.getFullYear() === currDate.getFullYear() &&
          txDate.getMonth() === currDate.getMonth() &&
          txDate.getDate() === currDate.getDate()
        );
      });
      setDailyTransactions(filtered);
       setIsLoading(false);
    })
    .catch(() => {
      setDailyTransactions([]);
      setIsLoading(false);
    });
};

// --- Navigation ---
const handleDayChange = (dir) => {
  const newDate = new Date(selectedDate);
  newDate.setDate(newDate.getDate() + dir);
  setSelectedDate(newDate);
  setCurrentPage(1);
  fetchTransactionsForDayWise(adminData.user_id, newDate);
};

 const handleMonthChange = (direction) => {
    const newDate = new Date(selectedMonth);
    newDate.setMonth(selectedMonth.getMonth() + direction);
    setSelectedMonth(newDate);
    fetchTransactionsForMonth(adminData.user_id, newDate);
  };

const calculateSummary = (transactions) => {
  let totalSelf = 0;   // recharge
  let totalReceived = 0; // from agent
  let totalSent = 0;   // to admin

  let rechargeCount = 0;
  let receivedCount = 0;
  let sentCount = 0;

  transactions.forEach((t) => {
    const amt = Number(t.amount);

    if (t.transaction_type === "SELF") {
      totalSelf += amt;
      rechargeCount++;
    }

    if (t.transaction_type === "AGENT") {
      totalReceived += amt;
      receivedCount++;
    }

    if (t.transaction_type === "ADMIN") {
      totalSent += amt;
      sentCount++;
    }
  });

  return {
    totalSelf, rechargeCount,
    totalReceived, receivedCount,
    totalSent, sentCount
  };
};


const dailySummary = calculateSummary(dailyTransactions);
const monthlySummary = calculateSummary(monthlyTransactions);

// --- Pagination Data ---
const transactionsToDisplay = activeTab === "daily" ? dailyTransactions : monthlyTransactions;
const indexOfLast = currentPage * itemsPerPage;
const indexOfFirst = indexOfLast - itemsPerPage;
const paginated = transactionsToDisplay.slice(indexOfFirst, indexOfLast);
const totalPages = Math.ceil(transactionsToDisplay.length / itemsPerPage);
const renderTransactionModal = () =>
  showTransactionsModal && (
    <div
      className="modal d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-xl modal-dialog-centered">
        <div className="modal-content">
          {/* Header */}
          <div className="modal-header CommonColor text-white">
            <h5 className="modal-title">Transactions</h5>
           
            <button
              className="btn-close"
              onClick={() => setShowTransactionsModal(false)}
            ></button>
          </div>

          <div className="modal-body">
             <div className="btn-group ms-3">
              <button
                className={`btn ${
                  activeTab === "daily" ? "CommonColor text-white" : "btn-light"
                }`}
                onClick={() => setActiveTab("daily")}
              >
                Daily
              </button>
              <button
                className={`btn ${
                  activeTab === "monthly" ? "CommonColor text-white" : "btn-light"
                }`}
                onClick={() => setActiveTab("monthly")}
              >
                Monthly
              </button>
            </div>
            {/* Date navigation */}
            <div className="d-flex justify-content-center align-items-center mb-3">
              <button
                className="btn CommonColor text-white rounded-circle me-2"
                onClick={() =>
                  activeTab === "daily"
                    ? handleDayChange(-1)
                    : handleMonthChange(-1)
                }
              >
                <FaArrowLeft />
              </button>
              <div
                className="CommonColor text-white px-4 py-2 rounded text-white fw-bold"
                style={{ cursor: "pointer" }}
                onClick={() => setShowPickerModal(true)}
              >
                {activeTab === "daily"
                  ? getDateLabel(selectedDate)
                  : formatMonthYearDisplay(selectedMonth)}
              </div>
              <button
                className="btn CommonColor text-white rounded-circle ms-2"
                onClick={() =>
                  activeTab === "daily"
                    ? handleDayChange(1)
                    : handleMonthChange(1)
                }
              >
                <FaArrowRight />
              </button>
            </div>

            {/* Summary Cards */}
            <div className="row text-center mb-3">
              <div className="col">
                <div className="border p-2 rounded">
                  Recharges <br />
                  <span>
                  {activeTab === "daily"
                    ? dailySummary.receivedCount + dailySummary.sentCount
                    : monthlySummary.receivedCount + monthlySummary.sentCount}
                </span>
                <br />
                <span className="text-success">
                  {activeTab === "daily"
                    ? dailySummary.totalSent
                    : monthlySummary.totalSent}{" "}
                  ↑
                </span> 
                <br />
                <span className="text-danger">
                  {activeTab === "daily"
                    ? dailySummary.totalReceived
                    : monthlySummary.totalReceived}{" "}
                  ↓
                </span>
                </div>
              </div>

              <div className="col">
                <div className="border p-2 rounded">
                  Received <br />
                  <span>
                    {activeTab === "daily"
                      ? dailySummary.sentCount
                      : monthlySummary.sentCount}
                  </span>
                  <br />
                  <span className="text-success">
                    {activeTab === "daily"
                      ? dailySummary.totalSent
                      : monthlySummary.totalSent}{" "}
                    ↑
                  </span>
                </div>
              </div>

              <div className="col">
                <div className="border p-2 rounded">
                  Sent <br />
                  <span>
                    {activeTab === "daily"
                      ? dailySummary.receivedCount
                      : monthlySummary.receivedCount}
                  </span>
                  <br />
                  <span className="text-danger">
                    {activeTab === "daily"
                      ? dailySummary.totalReceived
                      : monthlySummary.totalReceived}{" "}
                    ↓
                  </span>
                </div>
              </div>
            </div>

            {/* Transactions List */}
            <div className="divTblStyle">
              <div className="table-wrapper">
                <div className="table-responsive">
                  <table className="tblStyle">
                    <thead >
                      <tr className="theadtrStyle">
                        <th className="thStyle text-center">Date</th>
                        <th className="thStyle text-center">Txn ID</th>
                        <th className="thStyle text-center">By</th>
                        <th className="thStyle text-center">To</th>
                        <th className="thStyle text-center">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginated.length > 0 ? (
                        paginated.map((txn) => {
                          let typeLabel = txn.transaction_type;
                          let colorClass = "text-secondary";

                          if (txn.transaction_type === "SELF") {
                            colorClass = "td Styletext-success";
                          } else if (txn.transaction_type === "ADMIN") {
                            colorClass = "td Styletext-success";
                          } else if (txn.transaction_type === "AGENT") {
                            colorClass = "td Style text-danger";
                          }

                          return (
                            <tr key={txn.transaction_id}>
                              <td className="tdStyle">{txn.transaction_time}</td>
                              <td className="tdStyle">{txn.transaction_id}</td>
                              <td className="tdStyle">{txn.by_name}</td>
                              <td className="tdStyle">{txn.to_name}</td>
                              <td className={colorClass}>{txn.amount}</td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td  className="text-center" colSpan="5">No transactions found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="d-flex justify-content-center mt-3">
                <ul className="pagination">
                  <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage(currentPage - 1)}
                    >
                      Prev
                    </button>
                  </li>
                  {Array.from({ length: totalPages }, (_, i) => (
                    <li
                      key={i}
                      className={`page-item ${
                        currentPage === i + 1 ? "active" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => setCurrentPage(i + 1)}
                      >
                        {i + 1}
                      </button>
                    </li>
                  ))}
                  <li
                    className={`page-item ${
                      currentPage === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage(currentPage + 1)}
                    >
                      Next
                    </button>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );


const renderDatepickerModal = () =>
    showPickerModal && (
      <div
        className="modal d-block"
        tabIndex="-1"
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded">
            <div className="modal-header">
              <h5 className="modal-title fw-bold">
                {activeTab === "daily" ? "Select Date" : "Select Month"}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowPickerModal(false)}
              ></button>
            </div>
            <div className="modal-body text-center">
              <DatePicker
                selected={activeTab === "daily" ? selectedDate : selectedMonth}
                onChange={(date) => {
                  activeTab === "daily"
                    ? setSelectedDate(date)
                    : setSelectedMonth(date);
                }}
                dateFormat={activeTab === "daily" ? "dd/MM/yyyy" : "MM/yyyy"}
                inline
                showMonthYearPicker={activeTab === "monthly"}
              />
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => setShowPickerModal(false)}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={() => {
                  if (activeTab === "daily") {
                    fetchTransactionsForDayWise(
                      adminData.user_id,
                      selectedDate
                    );
                  } else {
                    fetchTransactionsForMonth(adminData.user_id, selectedMonth);
                  }
                  setShowPickerModal(false);
                  setCurrentPage(1); // Reset to first page when changing date
                }}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    );


  return (
    <div className="container">
        {/* Loader */}
    <div className="loader" style={IsLoading ? {} : { display: 'none' }}>
        <div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
      </div>
      <>
        {/* <Button variant="primary" onClick={handleShow}>
        Launch static backdrop modal
      </Button> */}
         {/* Admin popup contains device and card cout button click */}
        <Modal size="l"
  centered show={show} onHide={handleClose} backdrop="static" keyboard={false}>
          <Modal.Header className="CommonColor text-white" closeButton>
            <Modal.Title >Admin</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="divTblStyle">
            <div className="mb-2">
              <label className="form-label fw-bold">Name:</label>
              <label className="form-label">{adminData.name}</label>
            </div>
            <div className="mb-2">
              <label className="form-label fw-bold">Mobile:</label>
              <label className="form-label">{adminData.mobile}</label>
            </div>
            <div className="mb-2">
              <label className="form-label fw-bold">Email:</label>
              <label className="form-label">{adminData.email}</label>
            </div>
            <div className="mb-2">
              <label className="form-label fw-bold">Address:</label>
              <label className="form-label">{adminData.address_1 + ', ' + adminData.address_2}</label>
            </div>
            <div className="mb-2">
              <button variant="primary" className="btncommonColor text-white" onClick={() => handleTransactionsClick(adminData.user_id)}>Transactions</button>
            </div>
            </div>

            <div className="mb-1" style={{display:"flex",justifyContent:"space-evenly"}}>
              <button variant="primary"  className="divTblStyle" onClick={fnDeviceClick}>Devices<br></br>{deviceData}</button>
              <button variant="primary" className="divTblStyle" onClick={fnCardClick}>Cards<br></br>{cardData}</button>
            </div>
            <div className="p-4">
          <h4 className="fw-bold my-3">List of Organizations</h4>
          <table className="table table-hover border">
            <thead className="table-secondary">
              <tr className="">
                <th>Name</th>
                <th>Mobile</th>
              </tr>
            </thead>
            <tbody>
              {OrganizationListData
                .map((Data, idx) => (
                  <tr className="cursor-pointer" 
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate(`/SuperAdmin/organization/${Data.id}?isAd=true`)}
                    id="addr0" key={idx}>
                    <td>{Data.name}</td>                  
                    <td>{Data.code.split(',')[0]}</td>
                    {/* <td><Button variant="primary" onClick={() => handleShow(index)}>
                                            Details
                                        </Button></td> */}
                    {/*<td style={UserData.status_type === "APPROVED" ? { backgroundColor: 'green' } : UserData.status_type === "REJECTED" ? { backgroundColor: 'red' } : { backgroundColor: 'blue' } >{ UserData.status_type }</td>*/}
                  </tr>
                ))}
            </tbody>
          </table>
          <div className="text-center"><button className="super-admin-button" onClick={fnCreateOrganizationClick}>CREATE NEW ORGANIZATION</button></div>
        </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
       {/* Device popup */}
      {/* <Modal show={deviceShow} onHide={fnDeviceclosePopup} backdrop="static" keyboard={false}>
        <Modal.Header className="CommonColor text-white" closeButton>
          <Modal.Title>Admin</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className="">
            <thead>
              <tr className="">
                <th>Devices</th>
                <th><Button style={IsAllDelete ? {} : { display: 'none' }} variant="secondary" onClick={fnRemoveClick}>Delete</Button>
                  <input style={IsCheckAllBox ? {} : { display: 'none' }} type="checkbox" onChange={(event) => selectAll(event.target.checked)} checked={checkedAll} />
                </th>
              </tr>
            </thead>
            <tbody>
              {allocatedDevices.map((Data, idx) => (
                <tr className="" key={idx}>
                  <td>{Data.name}</td>
                  <td style={IsCheckBox ? {} : { display: 'none' }}> <input type="checkbox" onChange={() => toggleCheck(Data.id, idx)} checked={checked[Data.id]} /></td>
                  <td><Button  className="CommonColor text-white">Update Device Info</Button></td>
                  <td><Button className="CommonColor text-white" >Update Sim Recharge Info</Button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button style={IsBtnCancel ? {} : { display: 'none' }} variant="secondary" onClick={fnCancelClick}>
            Cancel
          </Button>
          <Button style={IsBtnDelete ? {} : { display: 'none' }} variant="secondary" onClick={fnRemoveDeviceClick}>
            Delete
          </Button>
          <Button  className="CommonColor text-white" style={IsBtnAddMore ? {} : { display: 'none' }} variant="secondary" onClick={fnAddMoreClick}>
            Add More
          </Button>
        </Modal.Footer>
      </Modal> */}
      {/* Device Management Modal */}
      <Modal
        show={deviceShow}
        onHide={fnDeviceclosePopup}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        {/* Header */}
        <Modal.Header className="CommonColor text-white" closeButton>
          <Modal.Title>Admin</Modal.Title>
        </Modal.Header>

        {/* Body */}
        <Modal.Body className="p-0">

          {/* Bulk Action Bar */}
          <div className="d-flex justify-content-between align-items-center px-3 py-2 border-bottom">
            <div className="d-flex align-items-center gap-2">
              {/* <input
                type="checkbox"
                style={{ visibility: IsCheckAllBox ? "visible" : "hidden" }}
                checked={checkedAll}
                onChange={(e) => selectAll(e.target.checked)}
              /> */}
              {/* <span className="fw-semibold">Select All</span> */}
               <span className="fw-semibold">Devices</span>
            </div>

            <Button
              variant="danger"
              size="sm"
              style={{ visibility: IsAllDelete ? "visible" : "hidden" }}
              onClick={fnRemoveClick}
            >
              Delete Selected
            </Button>
          </div>

          {/* Scrollable Table */}
          <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
            <table className="table table-hover align-middle mb-0">
              <thead className="table-light sticky-top">
                <tr>
                   <th><input
                      type="checkbox"
                      style={{ visibility: IsCheckAllBox ? "visible" : "hidden" }}
                      checked={checkedAll}
                      onChange={(e) => selectAll(e.target.checked)}
                    /></th>
                  <th>Device Name</th>
                  <th>Mobile No</th>
                  <th>Code</th>
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>
                {allocatedDevices.length === 0 ? (
                  <tr>
                    <td colSpan="3" className="text-center text-muted py-4">
                      No devices assigned. Click <strong>Add More</strong> to continue.
                    </td>
                  </tr>
                ) : (
                  allocatedDevices.map((Data, idx) => (
                    <tr key={idx}>
                      {/* Checkbox */}
                      <td>
                        <input
                          type="checkbox"
                          style={{ visibility: IsCheckBox ? "visible" : "hidden" }}
                          checked={checked[Data.id]}
                          onChange={() => toggleCheck(Data.id, idx)}
                        /> 
                      </td>

                      {/* Device Name */}
                      <td className="fw-semibold">{Data.name}</td>
                      <td className="fw-semibold">{Data.mobile_no}</td>
                      <td className="fw-semibold">{Data.code}</td>

                      {/* Actions */}
                      <td className="">
                        <div className="d-inline-flex gap-2">
                          <Button size="sm" className="CommonColor text-white"  onClick={() => openDeviceInfoPopup(Data)}>
                            Update Device Info
                          </Button>
                          <Button size="sm" variant="outline-secondary" onClick={()=>openRechargeInfoPopup(Data)}>
                            Update SIM Info
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>

        {/* Footer */}
        <Modal.Footer className="justify-content-between">
          <div>
            <Button
              variant="secondary"
              style={{ visibility: IsBtnCancel ? "visible" : "hidden" }}
              onClick={fnCancelClick}
            >
              Cancel
            </Button>

            <Button
              variant="danger"
              className="ms-2"
              style={{ visibility: IsBtnDelete ? "visible" : "hidden" }}
              onClick={fnRemoveDeviceClick}
            >
              Delete
            </Button>
          </div>

          <Button
            className="CommonColor text-white"
            style={{ visibility: IsBtnAddMore ? "visible" : "hidden" }}
            onClick={fnAddMoreClick}
          >
            Add More
          </Button>
        </Modal.Footer>
      </Modal>


      {/* Update Device Info Modal */}
      <Modal
        show={showDeviceInfoModal}
        onHide={closeDeviceInfoPopup}
        centered
        backdrop="static"
        keyboard={false}
      >

        {/* Header */}
        <Modal.Header className="CommonColor text-white justify-content-center" closeButton>
          <Modal.Title>Update Device Info</Modal.Title>
          
        </Modal.Header>

        {/* Body */}
        <Modal.Body className="px-4 py-3">

          {/* Device Number */}
          <div className="text-center text-muted fw-semibold mb-3">
            {cardCode}
          </div>

          {/* Name Field */}
          <div className="mb-3">
            <label className="form-label text-muted">Name</label>
            <input
              type="text"
              className={`form-control rounded ${errors.name ? "is-invalid" : ""}`}
              value={deviceName}
              onChange={(e) => {
                setDeviceName(e.target.value);
                setErrors({ ...errors, name: validateName(e.target.value) });
              }}
            />
            <div className="invalid-feedback">{errors.name}</div>
          </div>

          {/* Mobile Number Field */}
          <div className="mb-4">
            <label className="form-label text-muted">Mobile Number</label>
            <input
              type="text"
              className={`form-control rounded ${errors.mobile ? "is-invalid" : ""}`}
              value={mobileNumber}
              maxLength={10}
              onChange={(e) => {
                setMobileNumber(e.target.value);
                setErrors({ ...errors, mobile: validateMobile(e.target.value) });
              }}
            />
      <div className="invalid-feedback">{errors.mobile}</div>

          </div>

          {/* Submit Button */}
        <Button
              className="CommonColor text-white"
              onClick={fnSubmitDeviceUpdate}
              disabled={!!errors.name || !!errors.mobile}
            >
              SUBMIT
            </Button>


        </Modal.Body>
      </Modal>

      {/* Update Sim Recharge info Modal */}
      <Modal
        show={rechargeModalVisible}
        onHide={() => {
          setRechargeModalVisible(false);
          setPopupShow(true); // ✅ Show Device Management Modal again
        }}
        centered
        backdrop="static"
        keyboard={false}
        title="Update Sim Recharge Info"
      >
        {/* Header */}
        <Modal.Header className="CommonColor text-white justify-content-center" closeButton>
          <Modal.Title>Update Sim Recharge Info</Modal.Title>
          
        </Modal.Header>
        <Modal.Body className="px-4 py-3">
          {/* Mobile Number */}
          <div className="text-center text-muted fw-semibold mb-3">
            {mobileNumber}
          </div>
        {/* Recharge Date Field */}
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', fontSize: '14px', color: '#999', marginBottom: '5px' }}>
            Recharge Date
          </label>
          <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
            <input
              type="text"
              value={rechargeDate}
              readOnly
              placeholder="14 Jan 2026"
              style={{ 
                width: '100%',
                padding: '12px',
                paddingRight: '45px',
                border: '1px solid #ddd',
                borderRadius: '5px',
                fontSize: '16px'
              }}
            />
            <button 
              type="button"
              onClick={() => setShowDatePicker(!showDatePicker)}
              style={{
                position: 'absolute',
                right: '10px',
                background: 'none',
                border: 'none',
                fontSize: '20px',
                cursor: 'pointer',
                padding: '5px'
              }}
            >
              📅
            </button>
          </div>
          {showDatePicker && (
            <input
              type="date"
              onChange={(e) => {
                const date = new Date(e.target.value);
                const formatted = date.toLocaleDateString('en-GB', {
                  day: '2-digit',
                  month: 'short',
                  year: 'numeric'
                });
                setRechargeDate(formatted);
                setShowDatePicker(false);
              }}
              style={{
                marginTop: '10px',
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '5px'
              }}
            />
          )}
        </div>

        {/* Days Valid and Plan in Rs. Fields (Side by Side) */}
        <div style={{ display: 'flex', gap: '15px', marginBottom: '15px' }}>
          <div style={{ flex: 1 }}>
            <label style={{ display: 'block', fontSize: '14px', color: '#999', marginBottom: '5px' }}>
              Days Valid
            </label>
            <input
              type="number"
              value={daysValid}
              onChange={(e) => {
                setDaysValid(e.target.value);
                setErrors({ ...errors, daysValid: validateDaysValid(e.target.value) });
              }}
              placeholder="30"
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #ddd',
                borderRadius: '5px',
                fontSize: '16px'
              }}
            />
            {errors.daysValid && (
              <span style={{ color: 'red', fontSize: '12px', marginTop: '5px', display: 'block' }}>
                {errors.daysValid}
              </span>
            )}
          </div>

          <div style={{ flex: 1 }}>
            <label style={{ display: 'block', fontSize: '14px', color: '#999', marginBottom: '5px' }}>
              Plane in Rs.
            </label>
            <input
              type="number"
              value={planAmount}
              onChange={(e) => {
                setPlanAmount(e.target.value);
                setErrors({ ...errors, planAmount: validatePlanAmount(e.target.value) });
              }}
              placeholder="100"
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #ddd',
                borderRadius: '5px',
                fontSize: '16px'
              }}
            />
            {errors.planAmount && (
              <span style={{ color: 'red', fontSize: '12px', marginTop: '5px', display: 'block' }}>
                {errors.planAmount}
              </span>
            )}
          </div>
        </div>
             {/* Submit Button */}
        <Button
              className="CommonColor text-white"
              onClick={handleRechargeSubmit}
              disabled={!!errors.name || !!errors.mobile}
            >
              Submit
            </Button>

          
        
        </Modal.Body>
      </Modal>

       {/* Card popup */}
       <Modal show={cardShow} onHide={fnCardclosePopup} backdrop="static" keyboard={false}>
        <Modal.Header className="CommonColor text-white" closeButton>
          <Modal.Title>Admin</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className="">
            <thead>
              <tr className="">
                <th>Cards</th>
                <th><Button style={IsAllDeleteCards ? {} : { display: 'none' }} variant="secondary" onClick={fnRemoveCardsClick}>Delete</Button>
                  <input style={IsCheckAllBoxCards ? {} : { display: 'none' }} type="checkbox" onChange={(event) => selectAllCards(event.target.checked)} checked={checkedAllCards} />
                </th>
              </tr>
            </thead>
            <tbody>
              {allocatedCards.map((Data, idx) => (
                <tr className="" key={idx}>
                  <td>{Data.name}</td>
                  <td style={IsCheckBoxCards ? {} : { display: 'none' }}> <input type="checkbox" onChange={() => toggleCheckCards(Data.id, idx)} checked={checkedCards[Data.id]} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button style={IsBtnCancelCards ? {} : { display: 'none' }} variant="secondary" onClick={fnCancelCardsClick}>
            Cancel
          </Button>
          <Button style={IsBtnDeleteCards ? {} : { display: 'none' }} variant="secondary" onClick={fnDeleteCardsClick}>
            Delete
          </Button>
          <Button className="CommonColor text-white" style={IsBtnAddMoreCards ? {} : { display: 'none' }} variant="secondary" onClick={fnAddMoreCardsClick}>
            Add More
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Allocate Devices popup */}
      <Modal show={popupDeviceShow} onHide={fnCloseAddMorePopup} backdrop="static" keyboard={false}>
        <Modal.Header className="CommonColor text-white" closeButton>
          <Modal.Title>Allocate Devices</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className="">
            <thead>
              <tr className="">
                <th>Select All</th>
                <th>
                  <input type="checkbox" onChange={(event) => selectAllDevices(event.target.checked)} checked={checkedAll} />
                </th>
              </tr>
            </thead>
            <tbody>
              {availableDevices.map((Data, idx) => (
                <tr className="" key={idx}>
                  <td>{Data.name}</td>
                  <td> <input type="checkbox" onChange={() => toggleCheckDevices(Data.id, idx)} checked={checked[Data.id]} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="CommonColor text-white" onClick={fnAllocateNowClick}>
            ALLOCATE NOW
          </Button>
        </Modal.Footer>
      </Modal>
        {/* Allocate Cards popup */}
      <Modal show={popupCardShow} onHide={fnCloseAddMoreCardsPopup} backdrop="static" keyboard={false}>
        <Modal.Header className="CommonColor text-white" closeButton>
          <Modal.Title>Allocate Cards</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className="">
            <thead>
              <tr className="">
                <th>Select All</th>
                <th>
                  <input type="checkbox" onChange={(event) => selectAllCards(event.target.checked)} checked={checkedAllCards} />
                </th>
              </tr>
            </thead>
            <tbody>
              {availableCards.map((Data, idx) => (
                <tr className="" key={idx}>
                  <td>{Data.name}</td>
                  <td> <input type="checkbox" onChange={() => toggleCheckCards(Data.id, idx)} checked={checkedCards[Data.id]} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="CommonColor text-white" onClick={fnAllocateCardsNowClick}>
            ALLOCATE NOW
          </Button>
        </Modal.Footer>
      </Modal>
       {/* Main loading page that conatains list of admins */}
      <div className="form-outer">
        <button
      className="btn btn-outline-secondary mb-3"
       onClick={() => navigate(-1)}>
        ←Back
    </button>
        <div className="super-admin-header">
           
          <h1>Manage Admin</h1>
        </div>
        <div className="p-4">
        <h4 className="fw-bold mb-3">List of Admins</h4>
          <table className="table table-hover border">
            <thead className="table-secondary">
              <tr className="">
                <th>Name</th>
                <th>Mobile</th>
                <th>Email</th>
                <th>Address</th>
              </tr>
            </thead>
            <tbody>
              {AdminListData
         
                .map((Data, idx) => (
                  <tr className="" id="addr0" key={idx} onClick={() => fnAdmininfoClick(Data, idx)}>
                    <td>{Data.name}</td>
                    <td>{Data.mobile}</td>
                    <td>{Data.email}</td>
                    <td>{Data.address_1 + ', ' + Data.address_2}</td>
                    {/* <td><button variant="primary" onClick={() => fnAdmininfoClick(idx)}>
                                            Admin Details
                                        </button></td>  */}
                    {/*<td style={UserData.status_type === "APPROVED" ? { backgroundColor: 'green' } : UserData.status_type === "REJECTED" ? { backgroundColor: 'red' } : { backgroundColor: 'blue' } >{ UserData.status_type }</td>*/}
                  </tr>
                ))}
            </tbody>
          </table>
        <div className="text-center"><button className="super-admin-button" onClick={fnCreateAdminClick}>CREATE NEW ADMIN</button></div>
      </div>
        </div>

      {renderTransactionModal()}
      {renderDatepickerModal()}
    </div>
  );
};

export default ManageAdmin;